import { ScandataModel } from '../scandata/scandata.models';

export class SetHost3dScandata {
  static readonly type = '[Host 3d] SetAction';
  constructor(public readonly scandata: ScandataModel[]) {}
}

export class ClearHost3dScandata {
  static readonly type = '[Host 3d] ClearAction';
}

export class RotatePanoramas {
  static readonly type = '[Host 3d] RotatePanoramas';
  constructor(
    public readonly scanId: string,
    public readonly headingOffsetDegrees: number,
  ) {}
}
